import {Gender} from '@drl/core/auth/models/gender.enum';

import {
  Occurrence,
  PatientCGStatus,
  TreatmentStageId,
} from '../utility/patients-caregiver-utility.enum';
import {Caregiver} from './caregiver.model';
import { Role } from '@drl/core/store/models';

export class Patient {
  id?: number;
  userId?: number;
  caregiverId?: number;
  caregiver?: Caregiver;
  icdCode: string; // just a input field for now
  firstName: string;
  middleName?: string;
  lastName?: string;
  email?: string; // not required for alivio system
  roleId: number;
  externalId: string; // ehr id
  dob: Date;
  age: number;
  genderEnum: Gender;
  cancerType?: string;
  cancerTypeLc?: string;
  occurence?: Occurrence;
  treatmentStageId?: TreatmentStageId;
  careGroupId?: number;
  specialistId: number;
  phone: string; // could return null from ehr,  in that case we need to fill it
  statusEnum?: PatientCGStatus; // need to fill 0 while registering.
  comorbidity?: string;
  dietPlanId?: number;
  createdOn?: Date;
  photo?: string;
  photoUrl?: string; // sent in some apis from backend
  photoUrl1?: string; // sent in some apis from backend
  photoUrl2?: string; // sent in some apis from backend
  photoUrl3?: string; // sent in some apis from backend
  photoUrl4?: string; // sent in some apis from backend
  gender?: {id: string; name: string};// display logic
  carePlansId?: string;
  role?:Role;
  lastOtp?: string;
  lastOtpDate?: Date;
  tncVersion?:number;
  treatmentJourney?: number;
  treatmentJourneyDetails?: string;
  cancerStage?: number;
  waConsentTime?: Date;
  isSelfOnb: boolean;
  isAgeEntered?: boolean;
  tncAcceptedDate?: Date;
  isProvisional: boolean;
  isMinor: boolean;
  location: string;
  get fullName(): string {
    let fullName = this.firstName;
    if (this.middleName) {
      fullName = fullName.concat(' ').concat(this.middleName);
    }
    if (this.lastName) {
      fullName = fullName.concat(' ').concat(this.lastName);
    }
    return fullName;
  }

  constructor(data?: Partial<Patient>) {
    Object.assign(this, data);
  }
}
